import { type WebV1SurveysCheckDisplayListData } from '@credit-web/services/product-journey-girar'
import { type TransformTypesToCamelCase, SurveysCheckDisplayComponentType } from '@credit-web/services/types'
import camelcaseKeys from 'camelcase-keys'

/**
 * GET:/api/web/v1/surveys/{surveyKey}/check-display
 */
export const webV1SurveysCheckDisplayDetail: WebV1SurveysCheckDisplayListData = {
  content: {
    should_display_survey: true,
    survey_details: {
      survey_id: 'fedcba98-7654-3210-fedc-ba9876543210',
      survey_key: 'building_bff_disappointment_survey',
      title: 'Pesquisa de Satisfação - Empréstimo',
      description: 'Queremos entender melhor sua experiência com nossos produtos',
      questions: [
        {
          id: 'q1u2e3s4-t5i6-o7n8-i9d0-q1u2e3s4t5i6',
          title:
            'Se não mostrássemos exatamente o que falta para liberar sua oferta de crédito, quão desapontado você ficaria?',
          description: 'Queremos entender o quanto isso te ajudou',
          component_type: SurveysCheckDisplayComponentType.Score,
          question_type: 'SingleChoice',
          allow_custom_text: true,
          order: 1,
          options: [
            { id: 'opt1', text: 'Ter carência no pagamento' },
            { id: 'opt2', text: 'Escolher o número de parcelas' },
            { id: 'opt3', text: 'Escolher o percentual de recebimentos' },
            { id: 'opt4', text: 'Ter a opção de começar com parcelas menores' },
            { id: 'opt5', text: 'Não estou precisando no momento' },
            { id: 'opt6', text: 'Outro motivo', is_custom_text_option: true }
          ]
        }
      ]
    }
  },
  trace_key: 'sak_07294901329',
  is_valid: true
}

/**
 * GET:/api/web/v1/surveys/{surveyKey}/check-display
 */
export const webV1SurveysCheckDisplayDetailTransformed = () =>
  camelcaseKeys(webV1SurveysCheckDisplayDetail, {
    deep: true
  }) as TransformTypesToCamelCase<WebV1SurveysCheckDisplayListData>
